import gql from 'graphql-tag';

import shareRemoteItemResultFragment from '../fragments/shareRemoteItemResultFragment';

export const mutationShareRemoteItem = gql`
  mutation shareRemoteItem (
    $integrationID: DokkioID!
    $email: String!
    $remoteItemRemoteID: ID!
    $role: RemoteItemPermissionRole!
    $message: String
    $requireOnlyReadAccess: Boolean
  ) {
    shareRemoteItem (
      integrationID: $integrationID
      email: $email
      remoteItemRemoteID: $remoteItemRemoteID
      role: $role
      message: $message
      requireOnlyReadAccess: $requireOnlyReadAccess
    ) {
      ...shareRemoteItemResultFragment
    }
  }
  ${shareRemoteItemResultFragment}
`;
export default mutationShareRemoteItem;
